import React, {useState} from "react";
import {Container, Row, Col, Card, Form, Button, Image} from "react-bootstrap";
import {FaUserEdit, FaLock, FaSave} from "react-icons/fa";
import userInfo from "../data/user.json"; // Importamos los datos del usuario

const Profile = () => {
  // Estado para manejar los datos del usuario (ahora editables)
  const [user, setUser] = useState(userInfo);

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setUser({...user, [name]: value});
  };

  return (
    <Container fluid>
      <Row>
        {/* Columna de Información del Perfil */}
        <Col lg={8}>
          <Card className="mb-4">
            <Card.Header>
              <FaUserEdit className="me-2" />
              Información de la Cuenta
            </Card.Header>
            <Card.Body>
              <Row className="align-items-center">
                <Col md="auto" className="text-center mb-3 mb-md-0">
                  <Image
                    src={user.avatar || "/assets/user.png"}
                    roundedCircle
                    width={100}
                    height={100}
                  />
                </Col>
                <Col>
                  <Form>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="3">
                        Nombre Completo
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="name"
                          value={user.name}
                          onChange={handleInputChange}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="3">
                        Correo Electrónico
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="email"
                          name="email"
                          value={user.email}
                          onChange={handleInputChange}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm="3">
                        Rol
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="role"
                          value={user.role}
                          readOnly
                          className="text-muted"
                        />
                      </Col>
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer className="text-end">
              <Button variant="primary">
                <FaSave className="me-2" />
                Guardar Cambios
              </Button>
            </Card.Footer>
          </Card>

          {/* Columna para Cambiar Contraseña */}
          <Card>
            <Card.Header>
              <FaLock className="me-2" />
              Cambiar Contraseña
            </Card.Header>
            <Card.Body>
              <Form>
                <Form.Group className="mb-3" controlId="currentPassword">
                  <Form.Label>Contraseña Actual</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Contraseña actual"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="newPassword">
                  <Form.Label>Nueva Contraseña</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Nueva contraseña"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="confirmPassword">
                  <Form.Label>Confirmar Nueva Contraseña</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirmar nueva contraseña"
                  />
                </Form.Group>
              </Form>
            </Card.Body>
            <Card.Footer className="text-end">
              <Button variant="primary">Actualizar Contraseña</Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;
